import type { DataManagementDrawer } from '@/stores/type/project.type'

const getDrawerWidth = (drawer: DataManagementDrawer) => (drawer.shown ? drawer.width : 0)
export const useDrawerWidth = () => {
  const store = useProjectStore()
  const drawerWidth = computed(() => {
    const drawers = [
      store.profileDrawer,
      store.rasterDataDrawer,
      store.groundInvestigationDrawer,
      store.userManagementDrawer,
      store.labResultsDrawer,
      store.classificationDrawer
    ]
    for (const drawer of drawers) {
      const drawerWidth = getDrawerWidth(drawer)
      if (drawerWidth > 0) {
        return drawerWidth
      }
    }
    return 0
  })
  return { drawerWidth }
}
